import useAxios from '../../../library/axios'; 

import IBankRole, {IFormDef} from '../model/BankRole';

const _ = () => {

    const axios = useAxios();

    const saveBankRole = async (bankRole: IBankRole)  =>       
        await (await axios.post('/crm/bankRole/save', bankRole)).data;
    
    const getBankRole = async (roleID  : number )  => {        
      const {data} = (await axios.get(`/crm/bankRole/getBankRole/${roleID}`));
      return await data;
      }

    const getFormsList = async ()  : Promise<IFormDef[]>=> {
        const {data} = (await axios.get('/crm/bankRole/getFormsList'));
        return await data;
      }

    const getRolesList = async ()  => {
        const {data} = (await axios.get('/crm/bankRole/getRolesList'));
        return await data;
      }


    return {
        saveBankRole,
        getBankRole,

        getRolesList,
        getFormsList
      
    } 
}

export default _;